module.exports = __webpack_public_path__ + "static/media/chevron-left-bg.d2e66737.svg";